import {db, uuid} from "../Database.svelte";
import {readable} from "svelte/store";

export default class PositiveControl {
    constructor (control_id) {
        this.control = db.get(control_id)
    }

    static getPositiveControlList() {
        let control_list = [];

        return readable(undefined, (set) => {
            db.allDocs({
                startkey: "positiveControl:",
                endkey: "positiveControl:\ufff0",
                include_docs: true,

            }).then((results) => {
                control_list = results.rows.map(r => r.doc);
                set(control_list)
            })

            let changeMonitor = db.changes({
                since: "now",
                live: true,
                include_docs: true,
                filter: "filters/doc_type",
                query_params: {
                    type: 'positiveControl'
                }
            }).on('change', (change) => {
                if (change.deleted) {
                    control_list = control_list.filter(rec => rec._id != change.id);
                } else {
                    let found = false;
                    control_list = control_list.map((rec) => {
                        if (rec._id != change.id) return rec;
                        found = true;
                        return change.doc;
                    });

                    if (!found) control_list.push(change.doc);
                }

                set(control_list)
            })

            return () => {
                changeMonitor.cancel();
            }
        })
    }

    static getPositiveControl(control_id) {
        return db.get(control_id);
    }

    static createPositiveControl(control) {
        control.control_id = uuid();
        control._id = `positiveControl:${control.control_id}`;
        control.type = 'positiveControl';

        return db.put(control);
    }

    static savePositiveControl(control) {
        return db.put(control);
    }

    static deletePositiveControl(control) {
        control._deleted = true;
        return db.put(control);
    }
}